import React from 'react';
import SearchBar from './SearchBar';
import webapi from '../../../api/webapi';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import '../../css/react-tabs2.css';
import Loading from '../modal/Loading';


class SearchBox extends React.Component {
    constructor(props) {
        super(props);
    
        this.state = { books: [] };
        this.state = { chapters: [] };
        this.state = { SelectedBook: '' };
        this.state = { SelectedBookGroup: '' };
        this.state = { SelectedChapter: 'All' };
    }

    async componentDidMount() {
        this.setState({LoadingShow:true})
        this.setState({ SelectedBook: '' });
        this.setState({ SelectedBookGroup: '' });
        this.setState({ SelectedChapter: '' });

        this.setState({BookGroupShowAll: false});
        this.setState({BookShowAll: true});
        this.setState({ChapterShowAll: true});

        this.GetBookGroups();

        this.setState({LoadingShow:false})
    };


    GetBookGroups = async () =>{
        await webapi.get('surf/allbookgroups/'+this.props.Lang)
            .then(response => {
                this.setState({ BookGroups: response.data},() => {} );
            })
        if (this.state.BookGroups!==undefined)
        {
            if ((this.state.BookGroups.length===1)||(!this.state.BookGroupShowAll))
            {
                this.setState({ SelectedBookGroup : this.state.BookGroups[0].Code},() => {} );
                this.GetBooks(this.state.BookGroups[0].Code);
            }
            else
            {
                this.setState({ SelectedBookGroup : 'All' });
                this.GetBooks('All');
            }
        }
        else
        {
            this.setState({SelectedBook : ''})
            this.setState({SelectedChapter : ''})
        }
    }

    GetBooks = async BookGroupCode =>{
        this.setState({LoadingShow:true})
        await webapi.get('surf/bookgroupsbook/'+BookGroupCode+'/'+this.props.Lang)
            .then(response => {
                this.setState({ books: response.data });
            })
       
        if (this.state.books!==undefined)
        {
            if ((this.state.books.length===1)||(!this.state.BookShowAll))
            {
                this.setState({ SelectedBook : this.state.books[0].Code },() => {} )
                this.GetChapters(this.state.books[0].Code)
            }
            else
            {
                this.setState({ SelectedBook : 'All' });
                this.GetChapters('All');
            }
        }
        else
        {
            this.setState({SelectedBook : ''})
            this.setState({SelectedChapter : ''})
        }                
    }

    GetChapters = async BookCode =>{
        this.setState({LoadingShow:true})
        await webapi.get('surf/bookschapter/'+ BookCode+'/'+this.props.Lang)
            .then(response => {
                this.setState({ chapters: response.data });
            })

        if (this.state.chapters!==undefined)
        {
            if ((this.state.chapters.length===1)||(!this.state.ChapterShowAll))
            {
                this.setState({ SelectedChapter : this.state.chapters[0].Code })
            }
            else
            {
                this.setState({ SelectedChapter : 'All' });
            }
            
       }
       this.setState({LoadingShow:false})        
    }

    onChangeBookGroupSelect = async event => {
        this.setState({LoadingShow:true})
        this.setState({ results: '' });
        this.setState({ SelectedBookGroup: event.target.value});
        
        this.GetBooks(event.target.value);
    };

    onChangeBookSelect = async event => {
        this.setState({LoadingShow:true})
        this.setState({ results: '' });
        this.setState({ SelectedBook: event.target.value},()=>{});
        
        this.GetChapters( event.target.value );
    };

    onChangeChapterSelect = async event => {
        this.setState({ results: '' });
        this.setState({ SelectedChapter:event.target.value }, () => {})
    };

    onSelectTab = (tabIndex)=>{
        console.log(tabIndex);
        this.setState({ tabIndex : tabIndex});
        this.props.onSelectTab(tabIndex);
    }

    render() {
        return (
            <div className="container-fluid" id="words_search_form">
                <Loading LoadingShow={this.state.LoadingShow} />
                <div className="container">
                    <br />
                    {
                        //console.log("tabIndexChild", this.state.tabIndex)
                        //console.log("SelectedBookInSearchBox", this.state.SelectedBook)
                    }
                    {//alert("ren:"+this.state.SelectedBook)
                    }
                    <div className="select_param">           
                        <label>{this.props.pageData.length!==0 && this.props.pageData[0].F20201!== undefined?this.props.pageData[0].F20201:20201/*نوع متن*/}</label>
                        <select className="" id='select' onChange={this.onChangeBookGroupSelect}>
                            {   
                                this.state.BookGroups != null 
                                ?
                                this.state.BookGroups.map((bookgroup,i) =>{
                                    return  (
                                        [
                                            (((this.state.BookGroups.length>1) && (i===0)) && (this.state.BookGroupShowAll))
                                            ?
                                            <option key={"BookGroupAll"} value="All" select="true">{this.props.pageData.length!==0 && this.props.pageData[0].F29902!== undefined?this.props.pageData[0].F29902:29902/*همه*/}</option>
                                            :
                                            null
                                            ,
                                            <option key={bookgroup.Code} value={bookgroup.Code}>{bookgroup.Title}</option> 
                                        ]
                                    )
                                })
                                :
                                <option key="-1">-</option>       
                            }
                        </select>
                    </div>
                    <div className="select_param"> 
                        { 
                            (this.state.SelectedBookGroup==="2")
                            ?
                            <label>{this.props.pageData.length!==0 && this.props.pageData[0].F20204!== undefined?this.props.pageData[0].F20204:20204/*نوع کتیبه*/}</label>
                            :
                            <label>{this.props.pageData.length!==0 && this.props.pageData[0].F20201!== undefined?this.props.pageData[0].F20201:20201/*نام متن*/}</label>
                        }          
                        <select onChange={this.onChangeBookSelect} className="">
                            {   
                                this.state.books != null 
                                ?
                                this.state.books.map((book,i) =>{
                                    return  (
                                        [
                                            (((this.state.books.length>1) && (i===0)) && (this.state.BookShowAll))
                                            ?
                                            <option key={"BookAll"} value="All" select="true">{this.props.pageData.length!==0 && this.props.pageData[0].F29902!== undefined?this.props.pageData[0].F29902:29902/*همه*/}</option>
                                            :
                                            null
                                            ,
                                            <option key={book.Code} value={book.Code}>{book.Title}</option> 
                                        ]
                                    )
                                })
                                :
                                <option key="-1">-</option>       
                            }
                        </select>
                    </div>
                    <div className="select_param"> 
                        { 
                            (this.state.SelectedBookGroup==="2")
                            ?
                            <label>{this.props.pageData.length!==0 && this.props.pageData[0].F20205!== undefined?this.props.pageData[0].F20205:20205/*نام کتیبه*/}</label>
                            :
                            <label>{this.props.pageData.length!==0 && this.props.pageData[0].F20203!== undefined?this.props.pageData[0].F20203:20203/*شماره فصل*/}</label>
                        }
                        <select onChange={this.onChangeChapterSelect}  className="">
                            {   
                                this.state.chapters != null 
                                ?
                                this.state.chapters.map((chapter,i) =>{
                                    return  (
                                        [
                                            (((this.state.chapters.length>1) && (i===0)) && (this.state.ChapterShowAll))
                                            ?
                                            <option key={"ChapterAll"} value="All" select="true">{this.props.pageData.length!==0 && this.props.pageData[0].F29902!== undefined?this.props.pageData[0].F29902:29902/*همه*/}</option>
                                            :
                                            null
                                            ,
                                            <option key={chapter.Code} value={chapter.Code}>{chapter.Title}</option> 
                                        ]
                                    )
                                })
                                :
                                <option key="-1">-</option>       
                            }
                        </select>
                    </div>
                    <br />
                    
                    <Tabs   className ="search-tab" 
                            selectedTabPanelClassName="search_tab-panel--selected" 
                            selectedTabClassName="search_tab--selected"
                            disabledTabClassName="search_tab--disabled"
                            selectedIndex={this.props.tabIndex} 
                            //onSelect={tabIndex => this.setState({ tabIndex })}
                            onSelect={(tabIndex ) => this.onSelectTab(tabIndex)} 
                    >
                        
                        <TabList className="search-tab-list">
                            <Tab className ="search_tab">{this.props.pageData.length!==0 && this.props.pageData[0].F20214!== undefined?this.props.pageData[0].F20214:20214/*پهلوی*/}</Tab>
                            <Tab className ="search_tab">{this.props.pageData.length!==0 && this.props.pageData[0].F20210!== undefined?this.props.pageData[0].F20210:20210/*آوانویسی*/}</Tab>
                            <Tab className ="search_tab">{this.props.pageData.length!==0 && this.props.pageData[0].F20211!== undefined?this.props.pageData[0].F20211:20211/*حرف نویسی*/}</Tab>
                            <Tab className ="search_tab">{this.props.pageData.length!==0 && this.props.pageData[0].F20212!== undefined?this.props.pageData[0].F20212:20212/*معنی فارسی*/}</Tab>
                            <Tab className ="search_tab">{this.props.pageData.length!==0 && this.props.pageData[0].F20213!== undefined?this.props.pageData[0].F20213:20213/*بن واژه*/}</Tab>
                        </TabList>
                        <a href="/#" name={"Head"}> </a>
                        <TabPanel className ="search_tab-panel">
                            <SearchBar onSearchButtonClick={this.props.onSearchButtonClick} 
                                        SelectedBookGroup={this.state.SelectedBookGroup} 
                                        SelectedBook={this.state.SelectedBook} 
                                        SelectedChapter={this.state.SelectedChapter}
                                        PlaceHolder={this.props.pageData.length!==0 && this.props.pageData[0].F20224!== undefined?this.props.pageData[0].F20224:20224/*"جستجوی پهلوی"*/}
                                        ShowInClass={"Pahlavi"}
                                        pageData={this.props.pageData}
                            />
                            {/*تعداد {this.state.statments.length} عبارت پیدا شد*/}
                        </TabPanel>
                        <TabPanel className ="search_tab-panel">
                            <SearchBar onSearchButtonClick={this.props.onSearchButtonClick} 
                                        SelectedBookGroup={this.state.SelectedBookGroup} 
                                        SelectedBook={this.state.SelectedBook} 
                                        SelectedChapter={this.state.SelectedChapter}
                                        PlaceHolder={this.props.pageData.length!==0 && this.props.pageData[0].F20220!== undefined?this.props.pageData[0].F20220:20220/*"جستجوی آوانویسی"*/}
                                        ShowInClass={"Phonetic"}
                                        pageData={this.props.pageData}
                            />
                            {/*تعداد {this.state.statments.length} عبارت پیدا شد*/}
                        </TabPanel>
                        <TabPanel className ="search_tab-panel">
                            <SearchBar onSearchButtonClick={this.props.onSearchButtonClick}  
                                        SelectedBookGroup={this.state.SelectedBookGroup} 
                                        SelectedBook={this.state.SelectedBook} 
                                        SelectedChapter={this.state.SelectedChapter}
                                        PlaceHolder={this.props.pageData.length!==0 && this.props.pageData[0].F20221!== undefined?this.props.pageData[0].F20221:20221/*"جستجوی حرف نویسی"*/}
                                        ShowInClass={"english"}
                                        pageData={this.props.pageData}
                            />
                        </TabPanel>
                        <TabPanel className ="search_tab-panel">
                            
                            <SearchBar onSearchButtonClick={this.props.onSearchButtonClick}  
                                        SelectedBookGroup={this.state.SelectedBookGroup} 
                                        SelectedBook={this.state.SelectedBook} 
                                        SelectedChapter={this.state.SelectedChapter}
                                        PlaceHolder={this.props.pageData.length!==0 && this.props.pageData[0].F20222!== undefined?this.props.pageData[0].F20222:20222/*"جستجوی معنی فارسی"*/}
                                        ShowInClass={"farsi"}
                                        pageData={this.props.pageData}
                            />
                        </TabPanel>
                        <TabPanel className ="search_tab-panel">
                            <SearchBar  onSearchButtonClick={this.props.onSearchButtonClick}  
                                        SelectedBookGroup={this.state.SelectedBookGroup} 
                                        SelectedBook={this.state.SelectedBook} 
                                        SelectedChapter={this.state.SelectedChapter}
                                        PlaceHolder={this.props.pageData.length!==0 && this.props.pageData[0].F20223!== undefined?this.props.pageData[0].F20223:20223/*"جستجوی بن واژه"*/}
                                        ShowInClass={"Phonetic"}
                                        pageData={this.props.pageData}
                            />
                        </TabPanel>
                    </Tabs>
                </div>
                </div>
        )
    }
}

export default SearchBox;